const RP_VARIANTS = [
  {
    id: 0,
    name: "Obsidian Black",
    code: "01",
    bg: "linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%)",
    accent: "#4466aa",
    dot: "#1a1a1a",
    overlay: "rgba(0,0,0,0.55)"
  },
  {
    id: 1,
    name: "Brushed Silver",
    code: "02",
    bg: "linear-gradient(135deg, #1c2333 0%, #2a3a50 100%)",
    accent: "#c8d8e8",
    dot: "#c0c8d8",
    overlay: "rgba(10,15,25,0.5)"
  },
  {
    id: 2,
    name: "Crimson Steel",
    code: "03",
    bg: "linear-gradient(135deg, #0f0505 0%, #2a0808 100%)",
    accent: "#cc2200",
    dot: "#8b0000",
    overlay: "rgba(15,5,5,0.55)"
  },
  {
    id: 3,
    name: "Ocean Blue",
    code: "04",
    bg: "linear-gradient(135deg, #050d1a 0%, #0a1f3a 100%)",
    accent: "#2266ff",
    dot: "#1a3a6a",
    overlay: "rgba(5,10,25,0.5)"
  },
  {
    id: 4,
    name: "Forest Green",
    code: "05",
    bg: "linear-gradient(135deg, #050f05 0%, #0a2010 100%)",
    accent: "#22aa44",
    dot: "#1a4a1a",
    overlay: "rgba(5,10,5,0.55)"
  },
  {
    id: 5,
    name: "Champagne Gold",
    code: "06",
    bg: "linear-gradient(135deg, #100c02 0%, #221808 100%)",
    accent: "#c8a832",
    dot: "#8a6a10",
    overlay: "rgba(15,10,2,0.5)"
  },
  {
    id: 6,
    name: "Arctic White",
    code: "07",
    bg: "linear-gradient(135deg, #0a0a14 0%, #141428 100%)",
    accent: "#e8e8f8",
    dot: "#d0d0e8",
    overlay: "rgba(5,5,15,0.5)"
  },
  {
    id: 7,
    name: "Transparent",
    code: "08",
    bg: "linear-gradient(135deg, #050810 0%, #0a1020 100%)",
    accent: "#88ccff",
    dot: "#446688",
    overlay: "rgba(5,8,18,0.5)"
  }
];

class RPVariantSystem {
  constructor() {
    this.current = 0;
    this.transitioning = false;
    this.autoTimer = null;
    this.init();
  }

  init() {
    this.hero = document.querySelector('.hero, [data-section-type="hero"]');
    if (!this.hero) return;

    this.buildUI();
    this.applyVariant(0, false);
    this.startAuto();

    // Pause auto on hover
    this.hero.addEventListener('mouseenter', () => this.stopAuto());
    this.hero.addEventListener('mouseleave', () => this.startAuto());
  }

  buildUI() {
    // Wrapper
    const ui = document.createElement('div');
    ui.id = 'rp-variant-ui';
    ui.innerHTML = `
      <div id="rp-variant-info">
        <span id="rp-variant-code">01</span>
        <span id="rp-variant-name">Obsidian Black</span>
      </div>
      <div id="rp-variant-dots">
        ${RP_VARIANTS.map((v, i) => `
          <button
            class="rp-vdot${i === 0 ? ' rp-vdot--active' : ''}"
            data-index="${i}"
            aria-label="${v.name}"
          >
            <span class="rp-vdot__inner" style="background:${v.dot}"></span>
          </button>
        `).join('')}
      </div>
      <div id="rp-variant-arrows">
        <button id="rp-prev" aria-label="Previous">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.2"/>
          </svg>
        </button>
        <button id="rp-next" aria-label="Next">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.2"/>
          </svg>
        </button>
      </div>
    `;

    this.hero.appendChild(ui);

    // Overlay element
    this.overlay = document.createElement('div');
    this.overlay.id = 'rp-variant-overlay';
    this.hero.appendChild(this.overlay);

    // Bind dots
    ui.querySelectorAll('.rp-vdot').forEach(btn => {
      btn.addEventListener('click', () => {
        this.stopAuto();
        this.switchTo(parseInt(btn.dataset.index));
      });
    });

    // Arrows
    document.getElementById('rp-prev').addEventListener('click', () => {
      this.stopAuto();
      this.switchTo((this.current - 1 + RP_VARIANTS.length) % RP_VARIANTS.length);
    });
    document.getElementById('rp-next').addEventListener('click', () => {
      this.stopAuto();
      this.switchTo((this.current + 1) % RP_VARIANTS.length);
    });

    // Keyboard
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') { this.stopAuto(); this.switchTo((this.current - 1 + RP_VARIANTS.length) % RP_VARIANTS.length); }
      if (e.key === 'ArrowRight') { this.stopAuto(); this.switchTo((this.current + 1) % RP_VARIANTS.length); }
    });
  }

  switchTo(index) {
    if (this.transitioning || index === this.current) return;
    this.current = index;
    this.applyVariant(index, true);
  }

  applyVariant(index, animate) {
    const v = RP_VARIANTS[index];
    this.transitioning = animate;

    // Update dots
    document.querySelectorAll('.rp-vdot').forEach((btn, i) => {
      btn.classList.toggle('rp-vdot--active', i === index);
    });

    // Update info text
    const nameEl = document.getElementById('rp-variant-name');
    const codeEl = document.getElementById('rp-variant-code');

    if (animate && nameEl) {
      nameEl.style.opacity = '0';
      nameEl.style.transform = 'translateY(8px)';
      codeEl.style.opacity = '0';

      setTimeout(() => {
        nameEl.textContent = v.name;
        codeEl.textContent = v.code;
        nameEl.style.opacity = '1';
        nameEl.style.transform = 'translateY(0)';
        codeEl.style.opacity = '1';
      }, 300);
    } else if (nameEl) {
      nameEl.textContent = v.name;
      codeEl.textContent = v.code;
    }

    // Flash overlay
    if (animate && this.overlay) {
      this.overlay.style.background = v.accent;
      this.overlay.style.opacity = '0.12';
      this.overlay.style.transition = 'opacity 0.15s ease';
      setTimeout(() => {
        this.overlay.style.opacity = '0';
        this.overlay.style.transition = 'opacity 0.6s ease';
      }, 150);
    }

    // Background transition
    if (this.hero) {
      if (animate) {
        this.hero.style.transition = 'background 0.9s cubic-bezier(0.16,1,0.3,1)';
      }
      this.hero.style.background = v.bg;

      // Overlay color
      const heroOverlay = this.hero.querySelector('.hero__overlay, [class*="overlay"]');
      if (heroOverlay) {
        heroOverlay.style.transition = 'background 0.9s ease';
        heroOverlay.style.background = v.overlay;
      }
    }

    // Accent color for UI
    document.documentElement.style.setProperty('--rp-hero-accent', v.accent);

    if (animate) {
      setTimeout(() => { this.transitioning = false; }, 900);
    }
  }

  startAuto() {
    this.stopAuto();
    this.autoTimer = setInterval(() => {
      if (!this.transitioning) {
        this.switchTo((this.current + 1) % RP_VARIANTS.length);
      }
    }, 5000);
  }

  stopAuto() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window._rpVariants = new RPVariantSystem();
});
